import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1120vs1120 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Form 1120-S or 1120: Choose the Right Corporate Return"
          description="Understand key differences between Form 1120-S and Form 1120. Learn eligibility, tax rules, and choose the right corporate tax form for your business."
          keywords=""
          canonical="resources/business-tax/form-1120s-vs-form-1120-comparison/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          <span className="highlight-container">
            <span className="highlight">Form 1120-S</span>
          </span>{' '}
          vs.{' '}
          <span className="highlight-container">
            <span className="highlight">Form 1120</span>
          </span>
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/form-1120s-vs-form-1120-comparison/"
                  />

                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    itemProp="headline"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Form 1120-S vs. Form 1120 at a Glance
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    <span style={{ fontWeight: 600 }}>Form 1120-S</span> is
                    filed by eligible{' '}
                    <span style={{ fontWeight: 600 }}>S corporations</span>,
                    while <span style={{ fontWeight: 600 }}>Form 1120</span> is
                    filed by{' '}
                    <span style={{ fontWeight: 600 }}>C corporations</span> to
                    report their corporate income, deductions, and tax
                    liability.
                  </Typography>

                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="1" />
                      <span itemProp="name">
                        <span style={{ fontWeight: 600 }}>Form 1120-S:</span>{' '}
                        Used by eligible S corporations with an S corporation
                        election. Income, deductions, and credits generally{' '}
                        <span style={{ fontWeight: 600 }}>
                          pass through to shareholders
                        </span>
                        .
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="2" />
                      <span itemProp="name">
                        <span style={{ fontWeight: 600 }}>Form 1120:</span> Used
                        by C corporations to report{' '}
                        <span style={{ fontWeight: 600 }}>
                          corporate taxable income and federal income tax
                        </span>{' '}
                        at the entity level.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="3" />
                      <span itemProp="name">
                        <span style={{ fontWeight: 600 }}>Ownership:</span> S
                        corporations generally have a{' '}
                        <span style={{ fontWeight: 600 }}>
                          100-shareholder limit
                        </span>{' '}
                        and restrictions on eligible shareholders and stock
                        classes, while C corporations generally have{' '}
                        <span style={{ fontWeight: 600 }}>
                          no federal limit on the number or type of shareholders
                        </span>
                        .
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="4" />
                      <span itemProp="name">
                        <span style={{ fontWeight: 600 }}>
                          Which Form to File:
                        </span>{' '}
                        The correct form depends on the corporation's{' '}
                        <span style={{ fontWeight: 600 }}>
                          tax classification, S corporation eligibility,
                          ownership structure, and tax election
                        </span>
                        .
                      </span>
                    </li>
                  </Box>
                </Box>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  <Link
                    href="/business-returns/efile-irs-form-1120-s/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1120-S
                  </Link>{' '}
                  and Form 1120 are both corporate tax returns filed with the
                  IRS, but they apply to different business structures. Form
                  1120-S is used by S Corporations with pass-through taxation,
                  while Form 1120 is filed by C Corporations that pay corporate
                  income tax directly.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Understanding the differences helps businesses choose the
                  right tax structure and meet IRS filing requirements.
                </Typography>
                <Box sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }} />
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#corporation" sx={{ color: '#0202ff' }}>
                          S Corporation vs C Corporation
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#major" sx={{ color: '#0202ff' }}>
                          Major Differences Between Form 1120-S and Form 1120
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#eligibility" sx={{ color: '#0202ff' }}>
                          Eligibility Requirements
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#taxation" sx={{ color: '#0202ff' }}>
                          Taxation: Pass-Through vs Double Taxation
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#reporting" sx={{ color: '#0202ff' }}>
                          Reporting and Filing Requirements
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#determine" sx={{ color: '#0202ff' }}>
                          Determining Which Form to File
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#file" sx={{ color: '#0202ff' }}>
                          File Your Corporate Tax Return Effortlessly
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="corporation"
                >
                  S Corporation vs C Corporation
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            S Corporation
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            C Corporation
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            <strong style={{ fontWeight: 600, fontSize: 16 }}>
                              {' '}
                              Form 1120-S
                            </strong>
                            <br />
                            Filed by corporations or LLCs that have elected{' '}
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              S Corporation
                            </strong>{' '}
                            status by filing Form 2553.
                            <br />
                            <Box
                              component="ul"
                              sx={{ mb: 2, '& li': { mb: 1.2 } }}
                            >
                              <li>
                                Income, losses, and credits pass through to
                                shareholders.
                              </li>
                              <li>
                                Shareholders receive{' '}
                                <Link
                                  href="/resources/business-tax/schedule-k-1/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  {' '}
                                  Schedule K-1
                                </Link>{' '}
                                to report their share of income, deductions, and
                                credits.
                              </li>
                              <li>
                                Shareholder employees can receive a salary
                                separate from distributions.{' '}
                              </li>
                              <li>
                                Limited to 100 shareholders and generally allows
                                only one class of stock.
                              </li>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <strong style={{ fontWeight: 600, fontSize: 16 }}>
                              {' '}
                              Form 1120
                            </strong>{' '}
                            <br />
                            Filed by corporations that are taxed as{' '}
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              C Corporations
                            </strong>{' '}
                            by default or have not elected S Corp status.{' '}
                            <Box
                              component="ul"
                              sx={{ mb: 2, '& li': { mb: 1.2 } }}
                            >
                              <li>
                                Corporation pays taxes on its income at the
                                corporate level.
                              </li>
                              <li>
                                Shareholders may receive dividends, which can be
                                taxed separately from corporate income.
                              </li>
                              <li>
                                Shareholders are not treated as employees unless
                                they provide services to the corporation.
                              </li>
                              <li>
                                No limit on the number or type of shareholders.
                              </li>
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Box
                  component="div"
                  sx={{ mb: 4, p: 2, borderRadius: 2 }}
                  className="gradient-bg"
                >
                  <Stack
                    direction={{ xs: 'column', md: 'column' }}
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box sx={{}}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, mb: 1 }}
                      >
                        File your Form 1120-S with TaxZerone — secure, accurate,
                        and IRS-authorized.
                      </Typography>
                      <Typography variant="body2">
                        Benefit from automatic Schedule K-1 generation, error
                        checks, and expert support, all designed to simplify
                        your S Corporation tax return.
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        textAlign: 'left !important',
                        alignSelf: 'start',
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          textTransform: 'none',
                          boxShadow: 'none',
                          borderRadius: 2,
                          backgroundColor: '#fff',
                          color: '#333',
                          '&:hover, &:focus, &:active': {
                            color: '#fff',
                            background: '#172b6b',
                          },
                        }}
                        size="large"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120svs1120`}
                      >
                        Get started today
                      </Button>
                    </Box>
                  </Stack>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="major"
                >
                  Major Differences Between Form 1120-S and Form 1120
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 100, fontWeight: 600 }}
                          >
                            Feature
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Form 1120-S (S Corp)
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Form 1120 (C Corp)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>Taxation </TableCell>
                          <TableCell>
                            Pass-through: Income/losses reported by shareholders
                          </TableCell>
                          <TableCell>
                            Double taxation: Corporation pays tax; shareholders
                            taxed again on dividends
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Ownership </TableCell>
                          <TableCell>
                            Limited to 100 shareholders; all must be U.S.
                            persons
                          </TableCell>
                          <TableCell>
                            No restrictions; unlimited shareholders (U.S. and
                            foreign)
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Filing Forms </TableCell>
                          <TableCell>
                            1120-S + Schedule K-1 for each shareholder
                          </TableCell>
                          <TableCell>Only IRS 1120 Form</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Losses </TableCell>
                          <TableCell>
                            Can pass through to shareholders (limits apply)
                          </TableCell>
                          <TableCell>
                            Remain in the corporation; only usable by entity
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Stock </TableCell>
                          <TableCell>Only one class of stock allowed</TableCell>
                          <TableCell>
                            Multiple classes of stock allowed{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Eligible Entities </TableCell>
                          <TableCell>
                            Can pass through to shareholders (limits apply)
                          </TableCell>
                          <TableCell>
                            Remain in the corporation; only usable by entity
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Foreign Shareholders </TableCell>
                          <TableCell>Not permitted </TableCell>
                          <TableCell>Permitted</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Note :</b>For detailed guidance on the filing process,
                  refer to our{' '}
                  <Link
                    href="/resources/business-tax/form-1120-s-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1120s instructions
                  </Link>
                  .
                </Alert>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="eligibility"
                >
                  Eligibility Requirements
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            To file Form 1120-S
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            To file Form 1120
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Must be a domestic corporation or LLC that elected
                            corporate taxation
                          </TableCell>
                          <TableCell>
                            Domestic and foreign corporations taxed as C
                            Corporations.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Must file{' '}
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              Form 2553
                            </strong>{' '}
                            and receive IRS approval.
                          </TableCell>
                          <TableCell>No special election required.</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            No limit on the number of shareholders.
                          </TableCell>
                          <TableCell>
                            Limited to{' '}
                            <strong style={{ fontWeight: 600 }}>
                              100 shareholders
                            </strong>
                            .
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Individuals, corporations, partnerships, trusts, and
                            foreign investors are generally allowed.
                          </TableCell>
                          <TableCell>
                            Shareholders must generally be{' '}
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              U.S. citizens or resident individuals,
                            </strong>{' '}
                            certain trusts, or estates.
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                {/* <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Eligibility Requirements for S Corporations (Form 1120-S)
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  To{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1120-s/"
                    sx={{ color: '#0202ff' }}
                  >
                    file Form 1120-S
                  </Link>
                  , a corporation must meet strict IRS criteria, including:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Being a domestic corporation or LLC electing to be treated
                    as a corporation for tax purposes.
                  </li>
                  <li>It can have only allowable shareholders: </li>
                  <ul>
                    <li>
                      Individuals (U.S. citizens or resident aliens), certain
                      trusts, and estates.{' '}
                    </li>
                    <li>
                      Partnerships, corporations, and nonresident aliens cannot
                      be shareholders.{' '}
                    </li>
                  </ul>
                  <li>Limiting the number of shareholders to 100.</li>
                  <li>Issuing only one class of stock. </li>
                  <li>
                    All shareholders must be U.S. citizens or legal
                    residents.{' '}
                  </li>
                  <li>
                    All shareholders must consent to the S Corporation election
                    by signing Form 2553.{' '}
                  </li>
                </Box>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Failure to meet these requirements disqualifies the company
                  from S Corporation status, mandating internal revenue service
                  form 1120 filing instead.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Sources:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    {' '}
                    <Link
                      href="https://www.irs.gov/businesses/small-businesses-self-employed/s-corporations"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      IRS S Corporations | IRS.gov
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="https://www.irs.gov/forms-pubs/about-form-2553"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      IRS Form 2553 Instructions
                    </Link>{' '}
                  </li>
                </Box> */}

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="taxation"
                >
                  Taxation: Pass-Through vs Double Taxation
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Question
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            S Corps (Form 1120-S)
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            C Corps (Form 1120)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Who pays tax on profits?{' '}
                          </TableCell>
                          <TableCell>
                            Shareholders, directly on their personal returns
                          </TableCell>
                          <TableCell>
                            The corporation, on its own return
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Is there a corporate-level tax?{' '}
                          </TableCell>
                          <TableCell>
                            No, income passes through untaxed at the entity
                            level
                          </TableCell>
                          <TableCell>
                            Yes, the corporation pays federal tax on taxable
                            income
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Are dividends taxed again?{' '}
                          </TableCell>
                          <TableCell>No second layer of tax</TableCell>
                          <TableCell>
                            Yes, dividends are taxed again at the shareholder
                            level
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="reporting"
                >
                  Reporting and Filing Requirements
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            S Corporations
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            C Corporations
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>Form 1120-S, filed annually</TableCell>
                          <TableCell>Form 1120, filed annually</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              Schedule K-1
                            </strong>{' '}
                            prepared for each shareholder for Reporting{' '}
                          </TableCell>
                          <TableCell>
                            {' '}
                            <strong style={{ fontWeight: 600 }}>
                              No Schedule K-1
                            </strong>{' '}
                            is issued to shareholders.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Additional state returns filed if required
                          </TableCell>
                          <TableCell>
                            Separate state and local corporate returns may apply
                            depending on location
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="determine"
                >
                  Determining Which Form to File
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Choose Form 1120-S If...
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Choose Form 1120 If...
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Your business qualifies for S Corporation
                            status.{' '}
                          </TableCell>
                          <TableCell>
                            You need flexible ownership or plan to attract
                            investors.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            You want pass-through taxation to avoid double
                            taxation.
                          </TableCell>
                          <TableCell>
                            You plan to retain and reinvest profits in the
                            corporation.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            You want profits and losses to pass through to
                            shareholders.
                          </TableCell>
                          <TableCell>
                            You expect to have foreign shareholders or multiple
                            classes of stock.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Your business will have{' '}
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              100 or fewer eligible shareholders.
                            </strong>
                          </TableCell>
                          <TableCell>
                            Your business may have{' '}
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              more than 100 shareholders
                            </strong>{' '}
                            or ineligible owners.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Ownership will remain with eligible U.S.
                            shareholders.
                          </TableCell>
                          <TableCell>
                            You need fewer ownership restrictions and greater
                            fundraising flexibility.
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    scrollMarginTop: 83,
                  }}
                  id="file"
                >
                  File Your Corporate Tax Return Effortlessly
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Ensure your corporation’s tax filing matches your business
                  structure, growth plans, and investor strategy. Reviewing
                  eligibility and tax implications is essential for making the
                  best choice—and filing the correct form helps you avoid costly
                  errors and maximize tax advantages.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Ready to take the next step toward tax compliance and efficiency?
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              E-file Form 1120-S online quickly and securely with TaxZerone.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120svs1120`}
              >
                E-file Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1120vs1120;
